// File generated from our OpenAPI spec
export const ApiVersion = '2025-03-31.basil';
